module.exports = __webpack_public_path__ + "assets/img/jtfx1.2969376d.jpg";